export default "__VITE_ASSET__ic0rYaHZ__"